var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useLayoutEffect, useState } from "react";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import "@frameworks/salesjourney/stylesheets/components/Features/SalesReporting/IndividualReportView.scss";
import "@frameworks/salesjourney/stylesheets/components/Features/SalesReporting/ReportingCommonCss.scss";
import { getFieldType } from "./constant";
import GenericSidebar from "../../../../shared-library/components/GenericSidebar";
import AllReports from "./AllReports";
import moment from "moment";
import EdButton from "../../../../web/components/generic/edbutton/edButton";
import Loader from "../../../../shared-library/components/Loader";
import di from "./di/serviceLocator";
import { EAnswerInputType, } from "@frameworks/salesjourney/components/Generic/FormComponentGenerator";
import { useNavigate, useParams } from "react-router-dom";
import ReportTable from "./ReportTable";
import EdModal from "../../../../shared-library/components/edModal";
import Edelicon from "../../../../shared-library/components/Generic/Edelicon";
import FieldWrapper, { EFormCustomComponent } from "./FieldWrapper";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/salesjourney/components/Generic/ErrorNotification";
import { DownloadTimeCategory } from "../Downloads/downloadConstants";
var IndividualReportView = function () {
    var categoryId = useParams().categoryId;
    categoryId = atob(categoryId);
    var categoryName = useParams().categoryName;
    categoryName = atob(categoryName);
    var _a = __read(useState(null), 2), formData = _a[0], setFormData = _a[1];
    var _b = __read(useState(false), 2), viewAllReports = _b[0], setViewAllReports = _b[1];
    var _c = __read(useState(false), 2), loader = _c[0], setLoader = _c[1];
    var _d = __read(useState(false), 2), viewloader = _d[0], setViewloader = _d[1];
    var _e = __read(useState(false), 2), noDataFound = _e[0], setNoDataFound = _e[1];
    var _f = __read(useState(false), 2), isShowTable = _f[0], setIsShowTable = _f[1];
    var _g = __read(useState(null), 2), nextClickedPayload = _g[0], setNextClickedPayload = _g[1];
    var _h = __read(useState(undefined), 2), exportStatus = _h[0], setExportStatus = _h[1];
    var navigate = useNavigate();
    var _j = __read(useState(undefined), 2), allReportList = _j[0], setAllReportList = _j[1];
    var _k = __read(useState([]), 2), fieldInfo = _k[0], setfieldInfo = _k[1];
    var _l = __read(useState(false), 2), isView = _l[0], setIsView = _l[1];
    var _m = __read(useState(false), 2), isShowDownloadButton = _m[0], setIsShowDownloadButton = _m[1];
    var _o = __read(useState({}), 2), errorObj = _o[0], setErrorObj = _o[1];
    var _p = __read(useState(undefined), 2), tableData = _p[0], setTableData = _p[1];
    var _q = __read(useState(false), 2), sortingType = _q[0], setSortingType = _q[1];
    var _r = __read(useState(null), 2), clickedIndex = _r[0], setClickedIndex = _r[1];
    var _s = __read(useState(undefined), 2), initTableData = _s[0], setInitTableData = _s[1];
    var _t = __read(useState([]), 2), columnList = _t[0], setColumnList = _t[1];
    var _u = __read(useState(false), 2), tableClickViewPopup = _u[0], setTableClickViewPopup = _u[1];
    var _v = __read(useState(""), 2), htmlToRender = _v[0], setHtmlToRender = _v[1];
    var _w = __read(useState(""), 2), searchText = _w[0], setSearchText = _w[1];
    var _x = __read(useState(false), 2), showSearch = _x[0], setShowSearch = _x[1];
    var _y = __read(useState(false), 2), showToastForTableLink = _y[0], setShowToastForTableLink = _y[1];
    var _z = __read(useState(undefined), 2), orderby = _z[0], setOrderby = _z[1];
    var _0 = __read(useState(""), 2), clientStockHoldingRow = _0[0], setClientStockHoldingRow = _0[1];
    var _1 = __read(useState(false), 2), isSubmitClicked = _1[0], setIsSubmitClicked = _1[1];
    var _2 = __read(useState(), 2), tableViewRowColData = _2[0], setTableViewRowColData = _2[1];
    var _3 = __read(useState(""), 2), submitApiError = _3[0], setsubmitApiError = _3[1];
    var handleChange = function (name, value) {
        setFormData(function (form) {
            var _a;
            return __assign(__assign({}, form), (_a = {}, _a[name] = value, _a));
        });
    };
    var getReportFieldValues = function (reportID) {
        setLoader(true);
        di.salesReporting
            .getReportParamsData({ reportId: reportID })
            .then(function (resp) {
            var _a, _b;
            var fieldInfoArray = [];
            if (((_a = resp === null || resp === void 0 ? void 0 : resp.adminKpiFilterData) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                (_b = resp === null || resp === void 0 ? void 0 : resp.adminKpiFilterData) === null || _b === void 0 ? void 0 : _b.map(function (fieldValues) {
                    var _a, _b;
                    var fieldList = {
                        fieldName: fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.filter_name,
                        fieldType: getFieldType[(fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.filter_type) == "ddl" && !!(fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.multiple)
                            ? "multiddl"
                            : fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.filter_type],
                        isMandatory: fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.isMandatory,
                        fieldParams: fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.kpi_params,
                        id: fieldValues.id,
                        child_id: fieldValues.child_id,
                        cascade: fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.cascade,
                        multiSelect: !!(fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.multiple),
                        placeholder: fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.placeholder,
                        paramType: fieldValues.filter_type,
                        isDisabled: !!(fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.disabled),
                        defaultValue: (_a = fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.default_value) !== null && _a !== void 0 ? _a : "",
                        errorText: "",
                        radioOptions: (_b = fieldValues === null || fieldValues === void 0 ? void 0 : fieldValues.values) === null || _b === void 0 ? void 0 : _b.map(function (option) {
                            return {
                                display: option.name,
                                value: option.value,
                            };
                        }),
                    };
                    fieldInfoArray.push(fieldList);
                });
                setfieldInfo(fieldInfoArray);
            }
            setShowSearch(resp === null || resp === void 0 ? void 0 : resp.isSearchable);
            setIsView(resp === null || resp === void 0 ? void 0 : resp.isview);
            setIsShowDownloadButton(resp === null || resp === void 0 ? void 0 : resp.isdownload);
            setLoader(false);
            if (resp === null || resp === void 0 ? void 0 : resp.defaultView) {
                getTableColumnHeader();
                getReportTableData();
            }
        })
            .catch(function (error) {
            setLoader(false);
        });
    };
    var getSelectedInputValue = function (formData, fieldParams, defaultValue, isDisabled, paramType) {
        if (formData && formData[fieldParams]) {
            return formData[fieldParams];
        }
        if (isDisabled && defaultValue === "current_date") {
            return moment().format("DD-MM-YYYY");
        }
        if (isSubmitClicked &&
            (fieldParams === "DebitLedger" || fieldParams === "grosstock") &&
            formData &&
            (formData[fieldParams] === undefined ||
                formData[fieldParams] === null ||
                formData[fieldParams] === 0) &&
            (formData === null || formData === void 0 ? void 0 : formData.Date) &&
            (formData === null || formData === void 0 ? void 0 : formData.Accountcode)) {
            return defaultValue;
        }
        if (paramType === "number" && formData) {
            return undefined;
        }
        return "";
    };
    var getSelectedDropown = function (formData, fieldParams, multiSelect) {
        if (multiSelect && formData && formData[fieldParams]) {
            return formData[fieldParams];
        }
        else if (formData && formData[fieldParams]) {
            return [
                {
                    label: formData[fieldParams + "label"],
                    value: formData[fieldParams],
                },
            ];
        }
        else {
            return [];
        }
    };
    var getErrorText = function (isMandatory, formData, fieldParams) {
        if (isMandatory && formData && !formData[fieldParams]) {
            setErrorObj(function (prev) {
                var updatedObj = __assign(__assign({}, prev), { fieldParams: "This field is required" });
                return updatedObj;
            });
            return "This Field is required";
        }
        else
            return "";
    };
    function generateProps(_a) {
        var fieldName = _a.fieldName, fieldParams = _a.fieldParams, fieldType = _a.fieldType, isMandatory = _a.isMandatory, cascade = _a.cascade, child_id = _a.child_id, multiSelect = _a.multiSelect, errorText = _a.errorText, placeholder = _a.placeholder, paramType = _a.paramType, radioOptions = _a.radioOptions, isDisabled = _a.isDisabled, defaultValue = _a.defaultValue, id = _a.id;
        switch (fieldType) {
            case EAnswerInputType.DATE:
                return {
                    newSuffix: React.createElement("i", { className: "edel-icon-calendar-report" }),
                    datePickerProps: {
                        onChange: function (date) {
                            handleChange(fieldParams, moment(date).format("YYYY-MM-DD"));
                        },
                        selected: formData && formData[fieldParams]
                            ? new Date(formData[fieldParams])
                            : undefined,
                        dateFormat: "d-MMM-yyyy",
                        placeholderText: "DD-MMM-YYYY",
                        name: fieldParams,
                        id: fieldParams,
                        required: isMandatory,
                        showYearDropdown: true,
                        showMonthDropdown: true,
                        minDate: formData && formData.fromdate && fieldParams == "todate"
                            ? new Date(formData.fromdate)
                            : undefined,
                        yearDropdownItemNumber: 80,
                        scrollableYearDropdown: true,
                        autoComplete: "off",
                    },
                    errorText: formData && formData[fieldParams] ? "" : errorText,
                };
            case EAnswerInputType.SELECT:
                return {
                    defaultValue: getSelectedDropown(formData, fieldParams, multiSelect),
                    value: getSelectedDropown(formData, fieldParams, multiSelect),
                    name: fieldParams,
                    className: "DMSanN_14_400 txt_blackOne1",
                    classNamePrefix: "select",
                    onChange: function (e) {
                        if (multiSelect) {
                            handleChange(fieldParams, e);
                        }
                        else {
                            handleChange(fieldParams + "label", e.label);
                            handleChange(fieldParams, e.value);
                        }
                        if (cascade) {
                            var newFieldInfo = fieldInfo.map(function (fieldDetail) {
                                if (fieldDetail.id === child_id) {
                                    setFormData(function (prev) {
                                        var _a;
                                        var updatedData = __assign(__assign({}, prev), (_a = {}, _a[fieldDetail.fieldParams] = "", _a));
                                        return updatedData;
                                    });
                                    return __assign(__assign({}, fieldDetail), { parentSelectedValue: e.value });
                                }
                                else
                                    return fieldDetail;
                            });
                            setfieldInfo(newFieldInfo);
                        }
                    },
                    isSearchable: multiSelect,
                    closeMenuOnSelect: multiSelect ? false : true,
                    required: isMandatory,
                    isMulti: multiSelect,
                };
            case EAnswerInputType.BLANK_INPUT:
                return {
                    className: "generic-input-classname",
                    placeholder: placeholder ? placeholder : "Enter...",
                    onchange: function () { },
                    onChangeEvent: function (e) {
                        setIsSubmitClicked(false);
                        handleChange(fieldParams, paramType === "number" ? Number(e.target.value) : e.target.value);
                    },
                    defaultValue: getSelectedInputValue(formData, fieldParams, defaultValue, isDisabled, paramType),
                    required: (id === 39 || id === 40) &&
                        formData &&
                        formData.Date &&
                        (formData === null || formData === void 0 ? void 0 : formData.Accountcode)
                        ? false
                        : isMandatory,
                    name: fieldParams,
                    errorText: errorText,
                    autoComplete: "off",
                    type: paramType,
                    onKeyDown: function (keyEvent) {
                        if ((keyEvent.key == "e" || keyEvent.key === "E") &&
                            paramType === "number") {
                            keyEvent.preventDefault();
                        }
                    },
                    disabled: isDisabled,
                };
            case EAnswerInputType.CHECKBOX:
                return {
                    type: "checkbox",
                    label: "Checkbox",
                    onChange: function (e) {
                        handleChange(fieldParams, e.target.checked);
                    },
                    name: fieldParams,
                    required: isMandatory,
                };
            case EAnswerInputType.RADIO:
                return {
                    radioButtonList: radioOptions,
                    name: fieldParams,
                    onChange: function (e) {
                        handleChange(fieldParams, e.target.value);
                    },
                    selected: formData && formData[fieldParams]
                        ? formData[fieldParams]
                        : undefined,
                    className: "common-radio-button",
                    required: isMandatory,
                    label: fieldName,
                };
            case EAnswerInputType.DROPDOWN_SEARCH:
                return {
                    id: fieldParams,
                    onChange: function (e, selectedVal, isAllSelected) {
                        if (isAllSelected) {
                            handleChange(fieldParams, ["All"]);
                        }
                        else {
                            var selectedValues_1 = [];
                            selectedVal === null || selectedVal === void 0 ? void 0 : selectedVal.map(function (options) {
                                selectedValues_1.push(options === null || options === void 0 ? void 0 : options.value.toString());
                            });
                            handleChange(fieldParams, selectedValues_1);
                        }
                    },
                    reset: formData === null,
                };
            case EFormCustomComponent.DATE_RANGE:
                return {
                    onChange: function (e) {
                        handleChange(fieldParams, (e === null || e === void 0 ? void 0 : e.value) ? e === null || e === void 0 ? void 0 : e.value : "");
                    },
                    reset: formData === null,
                    SelectLabel: fieldName,
                };
            // default:
            //   return {};
        }
    }
    var getReportTableData = function (isDownload, page, orderby, hideTable) {
        if (isDownload === void 0) { isDownload = false; }
        if (hideTable === void 0) { hideTable = true; }
        if (hideTable) {
            setIsShowTable(false);
        }
        setLoader(true);
        var payload;
        if (nextClickedPayload && isDownload) {
            debugger;
            payload = {
                isDownload: true,
                page: "1",
                pageSize: "1000000",
                mainReqBody: {
                    kpi_id: nextClickedPayload.kpiId,
                    filter_params: nextClickedPayload.payload,
                    searchtext: searchText,
                    orderby: orderby,
                },
            };
        }
        else {
            payload = {
                isDownload: isDownload,
                page: page ? page.toString() : "1",
                pageSize: "50",
                mainReqBody: __assign(__assign({ kpi_id: Number(categoryId) }, (formData && { filter_params: formData })), { searchtext: searchText, orderby: orderby }),
            };
        }
        di.salesReporting
            .getReportData(payload)
            .then(function (resp) {
            var _a, _b, _c;
            if ((resp === null || resp === void 0 ? void 0 : resp.tabledata) && ((_a = resp === null || resp === void 0 ? void 0 : resp.tabledata) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                setTableData(resp);
                setIsShowTable(true);
                setNoDataFound(false);
                if (!initTableData) {
                    setInitTableData(resp);
                }
            }
            else if ((_b = resp === null || resp === void 0 ? void 0 : resp.isDownloadData) === null || _b === void 0 ? void 0 : _b.isDownload) {
                setExportStatus(resp === null || resp === void 0 ? void 0 : resp.isDownloadData);
            }
            else if ((resp === null || resp === void 0 ? void 0 : resp.tabledata) && ((_c = resp === null || resp === void 0 ? void 0 : resp.tabledata) === null || _c === void 0 ? void 0 : _c.length) === 0) {
                setTableData(undefined);
                setIsShowTable(true);
                setNoDataFound(false);
            }
            else {
                setIsShowTable(false);
                setTableData(undefined);
                setNoDataFound(true);
            }
            setLoader(false);
        })
            .catch(function (error) {
            setIsShowTable(false);
            setTableData(undefined);
            setNoDataFound(true);
            setLoader(false);
            if (error === null || error === void 0 ? void 0 : error.getMessage()) {
                setsubmitApiError(error === null || error === void 0 ? void 0 : error.getMessage());
            }
        });
    };
    var handleSubmit = function (isDownload) {
        if (isDownload === void 0) { isDownload = false; }
        var isError = false;
        if (tableViewRowColData) {
            setShowSearch(false);
            setTableViewRowColData(undefined);
        }
        fieldInfo === null || fieldInfo === void 0 ? void 0 : fieldInfo.forEach(function (fieldDetail) {
            if (isError)
                return;
            handleValidateFieldsForDebitReport(fieldDetail);
            if (fieldDetail.isMandatory && fieldDetail.fieldParams) {
                if (formData == null || formData == undefined) {
                    isError = true;
                    setfieldInfo(function (prev) {
                        var updatedInfo = prev === null || prev === void 0 ? void 0 : prev.map(function (item) {
                            if (item.fieldParams == fieldDetail.fieldParams) {
                                return __assign(__assign({}, item), { errorText: "This field is Required" });
                            }
                            else
                                return item;
                        });
                        return updatedInfo;
                    });
                }
                else if (formData &&
                    typeof formData === "object" &&
                    (!formData.hasOwnProperty(fieldDetail.fieldParams) ||
                        formData[fieldDetail.fieldParams] === undefined ||
                        formData[fieldDetail.fieldParams] === null ||
                        formData[fieldDetail.fieldParams] === "") &&
                    fieldDetail.fieldParams !== "DebitLedger" &&
                    fieldDetail.fieldParams !== "grosstock") {
                    isError = true;
                    setfieldInfo(function (prev) {
                        var updatedInfo = prev === null || prev === void 0 ? void 0 : prev.map(function (item) {
                            if (item.fieldParams == fieldDetail.fieldParams) {
                                return __assign(__assign({}, item), { errorText: "This field is Required" });
                            }
                            else
                                return item;
                        });
                        return updatedInfo;
                    });
                }
            }
        });
        if (isError)
            return;
        setSearchText("");
        if (isDownload) {
            return getReportTableData(true);
        }
        getTableColumnHeader();
        getReportTableData();
    };
    var getAllReports = function () {
        di.salesReporting
            .getAllReport()
            .then(function (resp) {
            setAllReportList(resp);
        })
            .catch(function (error) {
            console.log("error", error);
        });
    };
    var getTableColumnHeader = function () {
        di.salesReporting
            .getRmPartnerReportTableColumnHeader({ kpiId: categoryId })
            .then(function (resp) {
            if ((resp === null || resp === void 0 ? void 0 : resp.data.length) > 0) {
                setColumnList(resp.data);
            }
        })
            .catch(function (err) {
            setColumnList([]);
        });
    };
    var getColumnClickEventData = function (row, column, page) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if ((_a = column === null || column === void 0 ? void 0 : column.property) === null || _a === void 0 ? void 0 : _a.isView) {
            setViewloader(true);
            setHtmlToRender("");
            setTableClickViewPopup(true);
        }
        else {
            if (row && (column === null || column === void 0 ? void 0 : column.key) && row[column === null || column === void 0 ? void 0 : column.key])
                setClientStockHoldingRow(row[column === null || column === void 0 ? void 0 : column.key]);
            setLoader(true);
        }
        var payload = {
            kpiId: categoryId,
            page: page ? page : "1",
            pageSize: "50",
            requestObj: ((_b = column === null || column === void 0 ? void 0 : column.property) === null || _b === void 0 ? void 0 : _b.isView)
                ? {
                    AccountCode: (_c = row === null || row === void 0 ? void 0 : row.Client_Code) !== null && _c !== void 0 ? _c : "",
                    Date: (row === null || row === void 0 ? void 0 : row.DssDate) ? moment(row === null || row === void 0 ? void 0 : row.DssDate).format("YYYY-MM-DD") : "",
                    DebitLedger: (_d = row["Current Outstanding (NRML Debit Ledger)"]) !== null && _d !== void 0 ? _d : "",
                    Stock: row["GrossStock (NRML)"],
                    Type: !!formData && (formData === null || formData === void 0 ? void 0 : formData.Type) ? formData === null || formData === void 0 ? void 0 : formData.Type : "",
                }
                : {
                    EdelCode: (_e = row === null || row === void 0 ? void 0 : row.EdelCode) !== null && _e !== void 0 ? _e : (_f = tableViewRowColData === null || tableViewRowColData === void 0 ? void 0 : tableViewRowColData.row) === null || _f === void 0 ? void 0 : _f.EdelCode,
                    NSECode: (_g = row === null || row === void 0 ? void 0 : row.NSECode) !== null && _g !== void 0 ? _g : (_h = tableViewRowColData === null || tableViewRowColData === void 0 ? void 0 : tableViewRowColData.row) === null || _h === void 0 ? void 0 : _h.NSECode,
                    BSECode: (_j = row === null || row === void 0 ? void 0 : row.BSECode) !== null && _j !== void 0 ? _j : (_k = tableViewRowColData === null || tableViewRowColData === void 0 ? void 0 : tableViewRowColData.row) === null || _k === void 0 ? void 0 : _k.BSECode,
                    DealerNames: !!formData && (formData === null || formData === void 0 ? void 0 : formData.Dealer) ? formData === null || formData === void 0 ? void 0 : formData.Dealer : [],
                    searchtext: searchText,
                },
        };
        di.salesReporting
            .getRmPartnerReportTableClickEvent(payload)
            .then(function (resp) {
            var _a, _b, _c, _d, _e, _f;
            if ((resp === null || resp === void 0 ? void 0 : resp.data) && typeof (resp === null || resp === void 0 ? void 0 : resp.data) === "string") {
                setHtmlToRender(resp === null || resp === void 0 ? void 0 : resp.data);
            }
            else if ((resp === null || resp === void 0 ? void 0 : resp.isSucess) &&
                typeof (resp === null || resp === void 0 ? void 0 : resp.data) === "object" &&
                (resp === null || resp === void 0 ? void 0 : resp.data)) {
                setColumnList((_a = resp === null || resp === void 0 ? void 0 : resp.data) === null || _a === void 0 ? void 0 : _a.headers);
                setTableData((_b = resp === null || resp === void 0 ? void 0 : resp.data) === null || _b === void 0 ? void 0 : _b.datas);
                setShowSearch((_c = resp === null || resp === void 0 ? void 0 : resp.data) === null || _c === void 0 ? void 0 : _c.isSearchable);
                if ((_d = resp === null || resp === void 0 ? void 0 : resp.nextTablePayload) === null || _d === void 0 ? void 0 : _d.kpiId) {
                    setNextClickedPayload({
                        kpiId: (_e = resp === null || resp === void 0 ? void 0 : resp.nextTablePayload) === null || _e === void 0 ? void 0 : _e.kpiId,
                        payload: resp === null || resp === void 0 ? void 0 : resp.nextTablePayload.payload
                    });
                }
            }
            if (!(resp === null || resp === void 0 ? void 0 : resp.isSucess) && ((_f = column === null || column === void 0 ? void 0 : column.property) === null || _f === void 0 ? void 0 : _f.islink)) {
                setShowToastForTableLink(true);
            }
            else {
                setShowToastForTableLink(false);
            }
            setViewloader(false);
            setLoader(false);
        })
            .catch(function (e) {
            setViewloader(false);
            setShowToastForTableLink(true);
            setLoader(false);
        });
    };
    var getSortedTableData = function (e) {
        setOrderby({ colname: e === null || e === void 0 ? void 0 : e.key, acc: sortingType, dec: !sortingType });
        setSortingType(!sortingType);
        getReportTableData(false, undefined, {
            colname: e === null || e === void 0 ? void 0 : e.key,
            acc: sortingType,
            dec: !sortingType,
        }, false);
    };
    var handleValidateFieldsForDebitReport = function (fieldDetail) {
        if ((fieldDetail.fieldParams === "DebitLedger" ||
            fieldDetail.fieldParams === "grosstock") &&
            formData &&
            (formData === null || formData === void 0 ? void 0 : formData.Date) &&
            (formData === null || formData === void 0 ? void 0 : formData.Accountcode) &&
            ((formData === null || formData === void 0 ? void 0 : formData.DebitLedger) === undefined || (formData === null || formData === void 0 ? void 0 : formData.grosstock) === null)) {
            setfieldInfo(function (prev) {
                var updatedInfo = prev === null || prev === void 0 ? void 0 : prev.map(function (item) {
                    if (item.fieldParams == fieldDetail.fieldParams) {
                        return __assign(__assign({}, item), { defaultValue: "0" });
                    }
                    else
                        return item;
                });
                return updatedInfo;
            });
            setFormData(function (prev) { return (__assign(__assign({}, prev), { grosstock: 0, DebitLedger: 0 })); });
        }
    };
    useLayoutEffect(function () {
        getReportFieldValues(categoryId);
        getAllReports();
    }, []);
    useEffect(function () {
        var delayDebounceFn = setTimeout(function () {
            if ((searchText === null || searchText === void 0 ? void 0 : searchText.length) > 2) {
                if (categoryId === "20") {
                    getColumnClickEventData();
                }
                else {
                    getReportTableData();
                }
            }
            // else if (searchText?.length === 0 && initTableData) {
            //   if (categoryId === "20") {
            //     getColumnClickEventData();
            //   }
            // }
        }, 900);
        return function () { return clearTimeout(delayDebounceFn); };
    }, [searchText]);
    useEffect(function () {
        if (submitApiError) {
            var timer_1 = setTimeout(function () {
                setsubmitApiError("");
            }, 4000);
            return function () { return clearTimeout(timer_1); };
        }
    }, [submitApiError]);
    return (React.createElement(GridContainer, { parentClass: "loa-activity-container position-relative" },
        loader ? React.createElement(Loader, { className: "report-view-loader" }) : React.createElement(React.Fragment, null),
        React.createElement("div", { className: "header-container d-flex align-items-center justify-content-between" },
            React.createElement("span", { className: "DMSan_28_700 txt-midnight-blue" }, categoryName),
            React.createElement("span", { onClick: function () {
                    setViewAllReports(true);
                }, className: "cursor-pointer" },
                React.createElement("u", { className: "DMSan_16_700 txt-midnight-blue" }, "All Reports"))),
        React.createElement("form", { className: "loa-form bg_white  position-relative ", onSubmit: function (e) {
                e.preventDefault();
                var buttonText = "";
                if (e.nativeEvent instanceof SubmitEvent) {
                    buttonText = e.nativeEvent.submitter.innerHTML;
                }
                handleSubmit(buttonText === "Export");
            }, onReset: function () {
                setFormData(null);
                setIsShowTable(false);
                setSearchText("");
                setNextClickedPayload(null);
            } },
            React.createElement("div", { className: "loa-form-body formfield" }, fieldInfo === null || fieldInfo === void 0 ? void 0 : fieldInfo.map(function (fieldDetails) {
                if ((fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldName) && (fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldType))
                    return (React.createElement(FieldWrapper, { fieldName: fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldName, fieldType: fieldDetails === null || fieldDetails === void 0 ? void 0 : fieldDetails.fieldType, fieldDetails: generateProps(fieldDetails), fieldId: fieldDetails.id, parentSelectedValue: fieldDetails.parentSelectedValue }));
            })),
            React.createElement("div", { className: "d-flex justify-content-center align-items-center gap-2 loa-form-body" },
                (fieldInfo === null || fieldInfo === void 0 ? void 0 : fieldInfo.length) > 0 && isView && (React.createElement(React.Fragment, null,
                    " ",
                    React.createElement(EdButton, { onClick: function () {
                            setIsSubmitClicked(true);
                        }, btnTyp: "midnight-blue", value: "Submit", className: "form-btn", type: "submit" }),
                    React.createElement(EdButton, { onClick: function () { }, value: "Reset", className: "form-btn", btnTyp: "midnight-blue-border", type: "reset" }),
                    " ")),
                isShowDownloadButton && (React.createElement(EdButton, { onClick: function () {
                        // handleSubmit(true);
                    }, 
                    // disabled={isDownload}
                    type: "submit", btnTyp: "midnight-blue", value: "Export", className: "form-btn" }))),
            React.createElement("div", { className: "DMSanN_14_400 text-center red pb-3" }, submitApiError)),
        viewAllReports && (React.createElement(GenericSidebar, { parentClassname: "individual-report-sidebar", header: React.createElement("div", { className: "d-flex justify-content-between align-items-center " },
                React.createElement("div", { className: "DMSans_16_500 txt_blackOne1" }, "All Reports")), body: React.createElement("div", { className: "all-reports bg-white position-relative" },
                React.createElement(AllReports, { reports: allReportList })), footer: "", openKey: viewAllReports, setOpenKey: setViewAllReports, arrowClose: true, delay: 10 })),
        isShowTable && (React.createElement(ReportTable, { columnsList: columnList, tbodyData: tableData === null || tableData === void 0 ? void 0 : tableData.tabledata, showEntriesCount: true, currentPage: tableData === null || tableData === void 0 ? void 0 : tableData.currentpage, totalPages: tableData === null || tableData === void 0 ? void 0 : tableData.totalpages, getCurrentPage: function (page, isTableLinkView) {
                if (isTableLinkView) {
                    getColumnClickEventData(undefined, undefined, page === null || page === void 0 ? void 0 : page.toString());
                }
                else {
                    getReportTableData(false, page, orderby);
                }
            }, totalitems: tableData === null || tableData === void 0 ? void 0 : tableData.totalitems, pageSize: 50, kpiId: categoryId, formData: formData, getRowData: function (row, column) {
                setTableViewRowColData({ row: row, column: column });
                getColumnClickEventData(row, column);
            }, showHeader: showSearch, isShowSearch: showSearch, setSearchText: setSearchText, searchText: searchText, onSort: getSortedTableData, sortingType: sortingType, clickedIndex: clickedIndex, setClickedIndex: setClickedIndex })),
        noDataFound && isView && (React.createElement(ErrorNotification, { isOpen: true, errMsg: "No Data Found", displayType: ErrorDisplayType.INSECTION })),
        React.createElement("div", { className: "export-popup" },
            (exportStatus === null || exportStatus === void 0 ? void 0 : exportStatus.isDownload) && (React.createElement(EdModal, { show: exportStatus === null || exportStatus === void 0 ? void 0 : exportStatus.isDownload, setShow: function (val) {
                    setExportStatus(function (prev) { return (__assign(__assign({}, prev), { isDownload: val })); });
                }, size: "modal-dialog-centered", showFooter: false, modalTitle: " ", title: "Downloading", children: React.createElement("div", { className: "d-flex flex-column align-items-center justify-content-center export-child" },
                    React.createElement("div", { className: "mb-2" },
                        React.createElement(Edelicon, { className: "edel-icon-successful-icon", paths: 5 })),
                    React.createElement("div", { className: "mb-2 DMSanBold_18_700 txt-midnight-blue" }, exportStatus === null || exportStatus === void 0 ? void 0 : exportStatus.title),
                    React.createElement("div", { className: "DMSansNormal_12_400 txt_blue-tint mx-5 text-center text-block" }, exportStatus === null || exportStatus === void 0 ? void 0 : exportStatus.message),
                    React.createElement("div", { className: "hand_cursor d-flex align-items-center my-3" },
                        React.createElement(Edelicon, { className: "edel-icon-download-page me-2", paths: 3 }),
                        React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "My Downloads", onClick: function () {
                                setExportStatus(function (prev) { return (__assign(__assign({}, prev), { isDownload: false })); });
                                navigate("/dashboard/downloads", {
                                    state: { showToday: DownloadTimeCategory.TODAY },
                                });
                            } }))) })),
            tableClickViewPopup && (React.createElement(EdModal, { show: tableClickViewPopup, setShow: function (val) {
                    setTableClickViewPopup(val);
                }, size: "modal-dialog-centered", showFooter: false, modalTitle: "ageing-liquidation-title", title: "T5 Ageing and Liquidation", children: React.createElement("div", { className: "ageing-liquidation" }, viewloader ? (React.createElement("div", { className: "view-loader-block position-relative" },
                    React.createElement(Loader, null))) : htmlToRender && (htmlToRender === null || htmlToRender === void 0 ? void 0 : htmlToRender.length) > 0 ? (React.createElement(React.Fragment, null,
                    React.createElement("span", { dangerouslySetInnerHTML: { __html: htmlToRender } }),
                    React.createElement("div", { className: " d-flex align-items-center justify-content-end mt-3" },
                        React.createElement(EdButton, { onClick: function () {
                                setTableClickViewPopup(false);
                            }, value: "Close", className: "html-render-button", btnTyp: "midnight-blue", type: "button" }),
                        " "))) : (React.createElement(ErrorNotification, { isOpen: true, errMsg: "No Data Found", displayType: ErrorDisplayType.INSECTION }))) })),
            showToastForTableLink && (React.createElement(EdModal, { show: showToastForTableLink, setShow: function (val) {
                    setShowToastForTableLink(val);
                }, size: "modal-dialog-centered", showFooter: false, modalTitle: " ", title: clientStockHoldingRow, children: React.createElement("div", { className: " " },
                    React.createElement(ErrorNotification, { isOpen: true, errMsg: "No Data Found", displayType: ErrorDisplayType.INSECTION })) })))));
};
export default IndividualReportView;
